export const TransferIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_786_32956)">
      <path
        d="M12.0758 15.9998C12.2523 15.9975 12.4235 15.923 12.5455 15.7954L15.8042 12.5407C15.9283 12.4173 15.9992 12.2464 15.9992 12.0717C15.9992 11.8969 15.9282 11.7259 15.8044 11.6026L12.5479 8.34567C12.4215 8.21553 12.2479 8.14435 12.0675 8.14404H12.0662C11.795 8.14404 11.5543 8.30659 11.4531 8.5582C11.3516 8.80981 11.4123 9.09378 11.6077 9.2819L13.7344 11.4071H0.679322C0.499505 11.4036 0.325241 11.4719 0.198875 11.5956C0.072457 11.7192 0 11.8916 0 12.0685C0 12.2454 0.072457 12.4178 0.198875 12.5414C0.325445 12.6651 0.499301 12.7336 0.675858 12.7297L13.3715 12.7297H13.7405L11.6098 14.8608C11.4811 14.9854 11.4075 15.157 11.4062 15.3336C11.4051 15.5102 11.4762 15.6829 11.6012 15.8073C11.7264 15.9319 11.9002 16.0044 12.0758 15.9998Z"
        fill="black"
        fill-opacity="0.5"
      />
      <path
        d="M0.20548 3.45887C0.0814062 3.58243 0.010376 3.75333 0.010376 3.928C0.010376 4.10283 0.0814062 4.27373 0.205174 4.39683L3.46574 7.65842C3.58752 7.79029 3.76005 7.86784 3.93915 7.8712C4.11805 7.87462 4.2938 7.80364 4.42026 7.67661C4.54684 7.54953 4.61705 7.37389 4.61282 7.19468C4.60864 7.01522 4.53048 6.843 4.39841 6.72208L4.39346 6.71739L2.26908 4.5926H15.3239C15.6772 4.5848 15.9674 4.28805 15.9674 3.93116C15.9674 3.57443 15.6772 3.27778 15.3206 3.26993H2.26271L4.39346 1.13882C4.58984 0.94886 4.65007 0.654751 4.54515 0.405075C4.43866 0.151731 4.19123 -0.00780702 3.91755 0.000294707C3.74482 0.005543 3.58344 0.0766752 3.46314 0.200596L0.20548 3.45887Z"
        fill="black"
        fill-opacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_786_32956">
        <rect width="15.9992" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
